export default "__VITE_ASSET__fa41fabb__"